import React from 'react';
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';
import { useNavigate } from 'react-router-dom';
import { useTags } from '../../../hooks/useTags';
import buttonLang from '../../../data/lang/button.lang';


type Props = {
    title: string;
    withReturnBtn?: boolean;
}

const PageTitle = ({ title, withReturnBtn = false }: Props) => {

    const navigate = useNavigate();
    const { projectConfigState } = useProjectConfigContext();

    const generateTag = useTags();
    const returnHomeTag = generateTag(buttonLang, 'return-home');

    const projectId = projectConfigState.projectId;

    return (
        <>
            {(withReturnBtn && projectId > 0) && (
                <button
                    type="button"
                    onClick={() => navigate(`/home/${projectId}`)}
                    className="btn btn-link fs-5">{returnHomeTag}</button>
            )}
            <h1 style={{
                marginBottom: '1.5rem',
                textDecorationLine: 'underline',
                textDecorationColor: 'var(--bs-orange)',
            }}>{title}</h1>
        </>
    );
}

export default PageTitle;